import { jsx as _jsx } from "react/jsx-runtime";
import { useCookies } from 'react-cookie';
import { useNameOnlyApp, useNameOnlyAppWithCookie, useFingerPrintApp } from './nameOnlyApp.logic';
import { Loading, NewViewer } from './newViewer';
import FingerPrintProvider from '~/components/FingerPrintProvider';
const FingerPrintApp = () => {
    const [cookies] = useCookies(['OneroomAdminAPIToken']);
    const { token, verified, verifying, data } = useNameOnlyApp(cookies.OneroomAdminAPIToken, eventDataProps.data.id, eventDataProps.data.main_camera_id);
    const { fingerPrintContext, openFormModal } = useFingerPrintApp(data, verified, token);
    if (verifying) {
        return _jsx(Loading, {});
    }
    return (_jsx(FingerPrintProvider, { value: fingerPrintContext, children: _jsx(NewViewer, { openFormModal: openFormModal, nameOnly: true }) }));
};
const FingerPrintAppWithCookie = ({ data }) => {
    const { token, verified, verifying } = useNameOnlyAppWithCookie(eventDataProps.data.id, eventDataProps.data.main_camera_id, data);
    const { fingerPrintContext, openFormModal } = useFingerPrintApp(data, verified, token);
    if (verifying) {
        return _jsx(Loading, {});
    }
    return (_jsx(FingerPrintProvider, { value: fingerPrintContext, children: _jsx(NewViewer, { openFormModal: openFormModal, nameOnly: true }) }));
};
const App = () => {
    const [cookies] = useCookies(['OneroomFingerPrint']);
    console.log('cookies with free version', cookies);
    if (cookies.OneroomFingerPrint) {
        return _jsx(FingerPrintAppWithCookie, { data: cookies.OneroomFingerPrint });
    }
    else {
        return _jsx(FingerPrintApp, {});
    }
};
export default App;
